
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../capitalLedgerSlice";
import { fetchCapitalLedger,fetchCapitalAccountsBySearch } from "../capitalLedgerThunk";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";


const CapitalLedgerFilter = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, } = useSelector(
    (state) => state.capitalLedger
  );

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchCapitalLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

    const searchAccount = useCallback(
      (text) => dispatch(fetchCapitalAccountsBySearch(text)),
      [dispatch]
    );

    useDefaultDateRange(setFilters, filters, "today");

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
         <label>Search Account</label>
          <SearchListAutoComplete
            entityType="capital_account"
            searchThunk={searchAccount}
            resultSelector={(state) =>
              state.capitalLedger.capitalAccounts
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("accId", null);
                return;
              } 
              handleFilterChange("accId", obj?.sale_id);
            }}
            placeholder="Search Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
        filters={filters}
        onChange={(fromDate, toDate) => {
        handleFilterChange("fromDate", fromDate);
        handleFilterChange("toDate", toDate);
        }}
      />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CapitalLedgerFilter;

